import { Header } from '@rbilabs/universal-components';
import { AccessibilityProps, StyleSheet, ViewProps } from 'react-native';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { BadgeProgressBar } from 'pages/loyalty/loyalty-badges/badge-progress-bar';
import { LoyaltyBadgeImage } from 'pages/loyalty/loyalty-badges/loyalty-badge-image';
import { ILoyaltyBadge } from 'pages/loyalty/loyalty-badges/types';
import { primitive } from 'styles/constants';

import { BadgeBaseCard } from './badge-base-card';

export { BADGE_CARD_WIDTH, BADGE_CARD_MIN_HEIGHT } from './badge-base-card';

export const BadgeCard = ({
  badge,
  onPress,
  accessibilityRole,
  style,
}: {
  badge: ILoyaltyBadge;
  style?: ViewProps['style'];
  onPress?: () => void;
  accessibilityRole: AccessibilityProps['accessibilityRole'];
}) => {
  return (
    <BadgeBaseCard
      style={style}
      image={<LoyaltyBadgeImage badge={badge} style={styles.badgeImage} />}
      title={
        <Header variant="headerThree" style={styles.title} accessibilityLevel={3}>
          {badge.name}
        </Header>
      }
      subtitle={
        <SanityBlockRenderer
          content={badge.shortDescription}
          textProps={{ style: styles.subtitle }}
        />
      }
      progress={
        !badge.earnedAt && badge.progress && badge.progress.currentValue > 0 ? (
          <BadgeProgressBar progress={badge.progress} />
        ) : undefined
      }
      onPress={onPress}
      accessibilityLabel={badge.name}
      accessibilityRole={accessibilityRole}
    />
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: primitive.fontSizes.sm,
    marginBottom: 0,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: primitive.fontSizes.xs,
    textAlign: 'center',
    color: primitive.$blackOpacity70,
  },
  badgeImage: {
    width: 104,
    height: 104,
  },
});
